import { Component, DestroyRef, computed, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NAVIGATION_ITEMS, NavigationItem } from '../../layouts/main-layout/navigation-items';
import { PermissaoNivelService } from '../../../core/auth/services/permissao-nivel.service';
import { SessaoService } from '../../../core/auth/services/sessao.service';
import { I18nService } from '../../../core/i18n/services/i18n.service';
import { SideNavigationItemComponent } from '../side-navigation-item/side-navigation-item.component';

@Component({
  selector: 'app-side-navigation',
  standalone: true,
  imports: [NzIconModule, NzToolTipModule, SideNavigationItemComponent],
  templateUrl: './side-navigation.component.html',
  styleUrl: './side-navigation.component.scss'
})
export class SideNavigationComponent {
  private readonly router = inject(Router);
  private readonly permissao = inject(PermissaoNivelService);
  protected readonly sessao = inject(SessaoService);
  protected readonly i18n = inject(I18nService);
  protected readonly items = computed(() => this.filtrar(NAVIGATION_ITEMS));
  // Sair não navega: o clique no item encerra a sessão
  protected readonly itemSair = computed<NavigationItem>(() => ({ label: this.i18n.t('FEATURES.ACESSO.SAIR'), icon: 'logout' }));
  expanded = false;

  private filtrar(itens: NavigationItem[]): NavigationItem[] {
    return itens.filter(item => this.permissao.permiteNiveis(item.niveis))
      .map(item => item.links ? { ...item, links: this.filtrar(item.links) } : item)
      .filter(item => !item.links || item.links.length > 0);
  }

  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed(inject(DestroyRef)))
      .subscribe(() => (this.expanded = false));
  }
}
